import { render, staticRenderFns } from "./ViewModalObservaciones.vue?vue&type=template&id=7fe7fce4&"
import script from "./ViewModalObservaciones.vue?vue&type=script&lang=js&"
export * from "./ViewModalObservaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports